import { render, staticRenderFns } from "./Onaylama.vue?vue&type=template&id=dc598020&"
import script from "./Onaylama.vue?vue&type=script&lang=js&"
export * from "./Onaylama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports